import React, { FC, useEffect, useMemo, useState } from "react";
import { Carousel, Grid, Skeleton } from "../../../components";
import { useStore } from "effector-react";
import { LocationsEndpoint } from "../../../store/endpoints";
import { LocationCard } from "../../../cards";
import {
  $selectedLocation,
  setSelectedLocation,
} from "../../../store/selected/selectedLocations";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../../config";
import { GridBreakpoints } from "../../../components/Grid";
import { usePageSize } from "../../../hooks";

const gridBreakpoints: GridBreakpoints = {
  lg: 4,
  md: 6,
  sm: 6,
  xs: 12,
};

const Locations: FC = () => {
  const pageSize = usePageSize();

  const { t, i18n } = useTranslation(AppConfig.translationFileNames.step_Main);
  const { data: locations, pending, error } = useStore(
    LocationsEndpoint.list.store
  );
  const selectedLocation = useStore($selectedLocation);

  const [viewMode, setViewMode] = useState<"pages" | "carousel">(
    pageSize.md ? "pages" : "carousel"
  );

  useEffect(() => {
    setViewMode(pageSize.md ? "pages" : "carousel");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize.md]);

  useEffect(() => {
    LocationsEndpoint.list.call({
      _query: { page: 1, per_page: 99999, lang: i18n.language },
    });
  }, [i18n.language]);

  // When changed Language UI we need update description selectedLocation for Main page multilingual sections
  useEffect(() => {
    const updatedLanguageLocation = locations?.data.find((location) => {
      return location.id === selectedLocation?.id;
    });
    // If only one Location in list - select Location is not need
    if (locations && locations.data.length === 1) {
      setSelectedLocation(locations.data[0]);
    } else if (updatedLanguageLocation)
      setSelectedLocation(updatedLanguageLocation);
  }, [locations?.data]);

  const pendingData = useMemo(() => {
    return new Array(3).fill(null);
  }, []);

  const displayData = useMemo(() => {
    return locations?.data ?? [];
  }, [locations?.data]);

  return (
    <>
      <h2>{t("Location")}</h2>
      {viewMode === "pages" && (
        <Grid container gutter={[15, 15]}>
          {displayData.map((item) => (
            <Grid key={item.name} item {...gridBreakpoints}>
              <LocationCard
                data={item}
                onSelect={setSelectedLocation}
                selected={selectedLocation?.id === item.id}
              />
            </Grid>
          ))}
          {pending &&
            pendingData.map((_, idx) => (
              <Grid key={idx} item {...gridBreakpoints}>
                <Skeleton height={450} />
              </Grid>
            ))}
        </Grid>
      )}

      {viewMode === "carousel" && (
        <Carousel style={{ marginLeft: "" }}>
          {displayData.map((item) => (
            <LocationCard
              style={{ marginLeft: 10, marginRight: 10 }}
              key={item.name}
              data={item}
              onSelect={setSelectedLocation}
              selected={selectedLocation?.id === item.id}
            />
          ))}
        </Carousel>
      )}
      {error?.message}
    </>
  );
};

export default Locations;
